export const playerNames = [
  "Aerin",
  "Alaric",
  "Allison",
  "Alastair",
  "Aria",
  "Arwen",
  "Asher",
  "Athos",
  "Aurelia",
  "Aveline",
  "Azriel",
  "Caius",
  "Calla",
  "Calypso",
  "Cassius",
  "Cedric",
  "Celia",
  "Cerys",
  "Corin",
  "Darian",
  "Dax",
  "Delilah",
  "Dorian",
  "Draven",
  "Eira",
  "Elara",
  "Elric",
  "Elysia",
  "Emrys",
  "Enzo",
  "Evangeline",
  "Farin",
  "Felix",
  "Freya",
  "Galen",
  "Gideon",
  "Giselle",
  "Hadrian",
  "Halcyon",
  "Harlow",
  "Icarus",
  "Ilaria",
  "Isadora",
  "Isolde",
  "Jagger",
  "Jareth",
  "Jett",
  "Kaida",
  "Kairos",
  "Kalen",
  "Kian",
  "Kiera",
  "Kirena",
  "Lachlan",
  "Landon",
  "Leif",
  "Lennox",
  "Lirien",
  "Lysandra",
  "Maddox",
  "Magnus",
  "Marek",
  "Marigold",
  "Meliora",
  "Meridian",
  "Mirella",
  "Nadia",
  "Nerys",
  "Nikolai",
  "Nox",
  "Orion",
  "Orpheus",
  "Pandora",
  "Perseus",
  "Phoenix",
  "Raina",
  "Riven",
  "Roark",
  "Rowan",
  "Sabine",
  "Sable",
  "Samara",
  "Sariel",
  "Sashka",
  "Scott",
  "Wesley",
  "Seraphina",
  "Soren",
  "Sorin",
  "Sterling",
  "Tahlia",
  "Tarian",
  "Taryn",
  "Thalia",
  "Theron",
  "Tristan",
  "Uriel",
  "Vesper",
  "Viktor",
  "Xanthe",
  "Xavian",
  "Ysabel",
  "Zephyr",
];

export const townNames = [
  "Eldrid",
  "Arindor",
  "Evermore",
  "Isenmoor",
  "Faelond",
  "Sylvandale",
  "Misthaven",
  "Duskwood",
  "Greyfort",
  "Ravenhold",
  "Thistledown",
  "Luminair",
  "Arcadia",
  "Highwind",
  "Shadowvale",
  "Ashenfell",
  "Moonstone",
  "Ironhold",
  "Frosthold",
  "Starhaven",
  "Silverleaf",
  "Dragonspire",
  "Emberglade",
  "Wildewood",
  "Stormwatch",
  "Winterhaven",
  "Sunhaven",
  "Blackwater",
  "Windcrest",
  "Shadewood",
  "Bloodstone",
  "Nightshade",
  "Thundertree",
  "Fallowfield",
  "Shadowfall",
  "Driftwood",
  "Mistwood",
  "Dawnwatch",
  "Starfall",
  "Brightwater",
  "Suncrest",
  "Dragonreach",
  "Deephaven",
  "Sunstone",
  "Ironwood",
  "Goldcrest",
  "Firebrand",
  "Azurewatch",
  "Greenhaven",
  "Stonegate",
  "Snowhaven",
  "Windward",
  "Darkwater",
  "Ravenwood",
  "Foresthome",
  "Sunridge",
  "Blackwood",
  "Silverwood",
  "Stonehaven",
  "Brightwood",
  "Shadowkeep",
  "Stormhaven",
  "Winterwood",
  "Emberwood",
  "Riverwatch",
  "Heartwood",
  "Shadowwood",
  "Oakwood",
  "Frostwood",
  "Skyhold",
  "Seabreeze",
  "Lavender",
  "Hillcrest",
  "Sunflower",
  "Sunbeam",
  "Starlight",
  "Winterfell",
  "Sunburst",
  "Moonshadow",
  "Windwhisper",
  "Silvermist",
  "Firefly",
  "Bluebell",
  "Thunderbolt",
  "Pinecrest",
  "Mistyvale",
  "Oakleaf",
  "Snowflake",
  "Rosewood",
  "Wildflower",
  "Stonecrop",
  "Riverbend",
  "Autumnleaf",
  "Honeydew",
  "Mountainview",
  "Snowdrop",
  "Sunflower",
  "Moonstone",
  "Sapphire",
  "Frostflower",
];

export const villagerNames = [
  "Wesley",
  "Grimbok",
  "Thimble",
  "Puck",
  "Knickknack",
  "Tiddlywink",
  "Glimmer",
  "Boffin",
  "Fizzles",
  "Sniffles",
  "Glimwick",
  "Tinker",
  "Niblet",
  "Grouchy",
  "Poppet",
  "Sparky",
  "Wink",
  "Snickersnee",
  "Zephyr",
  "Fidget",
  "Cog",
  "Fizzlepop",
  "Bristle",
  "Moppet",
  "Flicker",
  "Crackle",
  "Widget",
  "Clank",
  "Hoggle",
  "Jingle",
  "Sprocket",
  "Twinkle",
  "Dobby",
  "Glimpse",
  "Snickerdoodle",
  "Skitter",
  "Niffy",
  "Clod",
  "Dabble",
  "Jibber",
  "Boggle",
  "Sprig",
  "Frizzle",
  "Jester",
  "Muddle",
  "Smidge",
  "Snicker",
  "Spindle",
  "Squeaker",
  "Tingle",
  "Tiptoe",
  "Whisp",
  "Wiggle",
  "Wisp",
  "Wrangle",
  "Blister",
  "Bubble",
  "Chirp",
  "Crimp",
  "Dink",
  "Fickle",
  "Fizz",
  "Flutter",
  "Gadget",
  "Gargoyle",
  "Glimp",
  "Grindle",
  "Grouse",
  "Hooch",
  "Hoot",
  "Kipper",
  "Miffy",
  "Nib",
  "Nipper",
  "Noddle",
  "Nudge",
  "Piddle",
  "Pip",
  "Pippet",
  "Pix",
  "Plink",
  "Plod",
  "Ploppy",
  "Puddle",
  "Quibble",
  "Rattle",
  "Scramble",
  "Screech",
  "Scuttle",
  "Shimmer",
  "Skedaddle",
  "Skimble",
  "Skittery",
  "Slither",
  "Snickle",
  "Sniffer",
  "Sniggle",
  "Snitch",
  "Snuffle",
  "Squawk",
  "Squib",
];

export const fighterNames = [
  "Talon",
  "Beak",
  "Cluck",
  "Feathers",
  "Cockadoodle",
  "Wing",
  "Peck",
  "Fowl",
  "Blade",
  "Slash",
  "Strike",
  "Fury",
  "Thrust",
  "Swipe",
  "Courage",
  "Valor",
  "Rooster",
  "Plume",
  "Dart",
  "Flare",
  "Claws",
  "Brawler",
  "Poultry",
  "Wingtip",
  "Cockerel",
  "Beakon",
  "Spike",
  "Scratch",
  "Comb",
  "Flight",
  "Hook",
  "Pluck",
  "Battle",
  "Spur",
  "Gallant",
  "Crest",
  "Grit",
  "Feather",
  "Blaze",
  "Valorant",
  "Brave",
  "Hatchet",
  "Spikester",
  "Peckish",
  "Wingman",
  "Raptor",
  "Sabre",
  "Fang",
  "Talonsome",
  "Stance",
  "Clawed",
  "Beakless",
  "Pecker",
  "Blazeheart",
  "Winglet",
  "Hack",
  "Thrasher",
  "Pugilist",
  "Plucky",
  "Pounce",
  "Charge",
  "Sword",
  "Avian",
  "Broil",
  "Edge",
  "Pluckiness",
  "Kick",
  "Cleave",
  "War",
  "Charger",
  "Clutch",
  "Slayer",
  "Fencer",
  "Peckster",
  "Beakdown",
  "Talonstrike",
  "Feisty",
  "Razor",
  "Plucker",
  "Peckpunch",
  "Wingding",
  "Pugnacious",
  "Hackles",
  "Pummel",
  "Featherdown",
  "Roost",
  "Saber",
  "Scratchy",
  "Flarewing",
  "Cocker",
  "Swashbuckler",
  "Poultrygeist",
  "Blazewing",
  "Wingbone",
  "Cluckdancer",
  "Fowlheart",
  "Spikeblade",
  "Wingtipper",
  "Talonstomp",
  "Devin",
];

export const archerNames = [
  "Gabrielle",
  "Adira",
  "Bianca",
  "Calantha",
  "Darya",
  "Eira",
  "Farah",
  "Galena",
  "Hazel",
  "Isadora",
  "Jocasta",
  "Kaida",
  "Leila",
  "Morgana",
  "Nyx",
  "Odette",
  "Phaedra",
  "Quinn",
  "Rhea",
  "Selene",
  "Thalia",
  "Ula",
  "Vesper",
  "Willow",
  "Xandra",
  "Yara",
  "Ziva",
  "Aria",
  "Brigid",
  "Calla",
  "Danika",
  "Elara",
  "Freya",
  "Gwyneth",
  "Helene",
  "Isla",
  "Juniper",
  "Kaela",
  "Lyra",
  "Maren",
  "Niamh",
  "Orla",
  "Petra",
  "Quilla",
  "Riven",
  "Seraphina",
  "Tahlia",
  "Una",
  "Vega",
  "Winter",
  "Xanthe",
  "Ysabel",
  "Zephyr",
  "Aurora",
  "Bellamy",
  "Corinna",
  "Delaney",
  "Evangeline",
  "Fae",
  "Genevieve",
  "Hannelore",
  "Isadora",
  "Jaeda",
  "Kaida",
  "Lirien",
  "Marcella",
  "Nessa",
  "Odessa",
  "Phoenix",
  "Quinley",
  "Romy",
  "Sariel",
  "Tamsin",
  "Ursula",
  "Valencia",
  "Waverly",
  "Xena",
  "Yvette",
  "Zaina",
  "Artemis",
  "Brenna",
  "Cleo",
  "Drusilla",
  "Eowyn",
  "Freesia",
  "Gwynn",
  "Harper",
  "Ione",
  "Jolene",
  "Kaida",
  "Laurel",
  "Meliora",
  "Niamara",
  "Octavia",
  "Primrose",
  "Rowan",
  "Sage",
  "Tauriel",
  "Uma",
  "Vespera",
  "Xylia",
];

export const knightNames = [
  "Scott",
  "Galahad",
  "Arthur",
  "Lancelot",
  "Percival",
  "Gawain",
  "Tristan",
  "Gareth",
  "Bedevere",
  "Kay",
  "Bors",
  "Leodegrance",
  "Lionel",
  "Lucan",
  "Palamedes",
  "Agravain",
  "Balin",
  "Caradoc",
  "Dagonet",
  "Ector",
  "Hector",
  "Ivor",
  "Lamorak",
  "Mordred",
  "Morholt",
  "Ogier",
  "Pellinore",
  "Sagramore",
  "Urien",
  "Ywain",
  "Cador",
  "Dulac",
  "Elyan",
  "Gareth",
  "Galvano",
  "Kayne",
  "Langward",
  "Marken",
  "Norburn",
  "Othian",
  "Pendrake",
  "Quinleigh",
  "Rawlins",
  "Skellington",
  "Tannermoor",
  "Uther",
  "Valiant",
  "Wynward",
  "Xenos",
  "Yaldir",
  "Zalman",
  "Anselm",
  "Balthazar",
  "Cedric",
  "Darian",
  "Emric",
  "Frederick",
  "Gaius",
  "Hadrian",
  "Icarus",
  "Jareth",
  "Kael",
  "Leif",
  "Magnus",
  "Nathair",
  "Orin",
  "Pyrus",
  "Quinlan",
  "Reginald",
  "Silas",
  "Tristan",
  "Ulysses",
  "Varian",
  "Warrick",
  "Xander",
  "Yorick",
  "Zander",
  "Arin",
  "Branson",
  "Caius",
  "Daxton",
  "Everett",
  "Finnian",
  "Gavriel",
  "Holden",
  "Isidore",
  "Jasper",
  "Kian",
  "Lucius",
  "Maximus",
  "Niles",
  "Octavius",
  "Phineas",
  "Regis",
  "Seth",
  "Thaddeus",
  "Usher",
  "Vance",
  "Walden",
  "Xavier",
  "Zephyr",
  "Aela",
  "Brienne",
  "Carina",
  "Danika",
  "Eira",
  "Freya",
  "Gwendolyn",
  "Helga",
  "Ingrid",
  "Johanna",
  "Kaida",
  "Lyra",
  "Morgana",
  "Nyx",
  "Orla",
  "Philippa",
  "Quinn",
  "Rowena",
  "Seraphina",
  "Thora",
  "Ursa",
  "Valkyrie",
  "Winona",
  "Xandra",
  "Ylva",
  "Zara",
  "Ada",
  "Brigid",
  "Cerys",
  "Darya",
  "Elspeth",
  "Farah",
  "Galene",
  "Hilda",
  "Iona",
  "Jorunn",
  "Kaela",
  "Lirien",
  "Maren",
  "Niamh",
  "Odette",
  "Phaedra",
  "Rhiannon",
  "Sariel",
  "Tahlia",
  "Una",
  "Valdis",
  "Wren",
  "Xanthe",
  "Yara",
  "Ziva",
  "Adira",
  "Bellona",
  "Cordelia",
  "Delaney",
  "Elinor",
  "Fae",
  "Giselle",
  "Hecate",
  "Isadora",
  "Jaina",
  "Kaida",
  "Leona",
  "Morrigan",
  "Nessa",
  "Ophelia",
  "Petra",
  "Quintessa",
  "Rosalind",
  "Sable",
  "Tamsin",
  "Ulrica",
  "Viviana",
  "Waverly",
  "Xena",
  "Ysabel",
  "Zelda",
  "Amara",
  "Briar",
  "Calliope",
  "Dariana",
  "Eowyn",
  "Fianna",
  "Galiana",
  "Harper",
  "Isla",
  "Juliana",
  "Kaida",
  "Lorelei",
  "Meliora",
  "Niamara",
  "Octavia",
  "Persephone",
  "Quinneth",
  "Rowan",
  "Sarielle",
  "Tauriel",
  "Una",
  "Vespera",
  "Xylia",
];

export const mageNames = [
  "Allison",
  "Aelwyn",
  "Belinda",
  "Calantha",
  "Danika",
  "Eirlys",
  "Fae",
  "Galadriel",
  "Helene",
  "Iridessa",
  "Jinx",
  "Kaida",
  "Lirien",
  "Morrigan",
  "Nyx",
  "Ophelia",
  "Pandora",
  "Quinn",
  "Rhiannon",
  "Selene",
  "Tahlia",
  "Ula",
  "Vesper",
  "Willow",
  "Xanthe",
  "Yara",
  "Zephyra",
  "Althea",
  "Briar",
  "Clio",
  "Darcy",
  "Elvira",
  "Fleur",
  "Ginevra",
  "Hecate",
  "Iseult",
  "Juniper",
  "Kaida",
  "Lyris",
  "Morgana",
  "Niamh",
  "Orla",
  "Phaedra",
  "Qadira",
  "Riven",
  "Sariel",
  "Thalia",
  "Una",
  "Vega",
  "Waverly",
  "Xandra",
  "Ysadora",
  "Zareen",
  "Aria",
  "Brigid",
  "Circe",
  "Delfina",
  "Eowyn",
  "Freesia",
  "Guinevere",
  "Hannelore",
  "Isadora",
  "Jocasta",
  "Kaida",
  "Lillith",
  "Marcella",
  "Noemi",
  "Odessa",
  "Phoenix",
  "Qiana",
  "Romy",
  "Seraphina",
  "Tamsin",
  "Uriela",
  "Valora",
  "Wren",
  "Xiomara",
  "Yvette",
  "Zaina",
  "Astrid",
  "Belladonna",
  "Celeste",
  "Drusilla",
  "Elaina",
  "Faustina",
  "Gwendolyn",
  "Hermione",
  "Isla",
  "Jolene",
  "Kaida",
  "Lysandra",
  "Meliora",
  "Niamara",
  "Ondine",
  "Pyrrha",
  "Rowan",
  "Sabrina",
  "Tauriel",
  "Ursula",
  "Vespera",
  "Xylara",
];

export const bombirdNames = [
  "Alaric",
  "Bertram",
  "Caspian",
  "Darian",
  "Eldred",
  "Fabian",
  "Gideon",
  "Hadrian",
  "Ignatius",
  "Jarek",
  "Kael",
  "Lazarus",
  "Magnus",
  "Nikolai",
  "Oberon",
  "Ptolemy",
  "Quade",
  "Rafferty",
  "Seamus",
  "Thaddeus",
  "Ulrich",
  "Victor",
  "Wesley",
  "Wolfgang",
  "Xander",
  "Yorick",
  "Zephyr",
  "Adair",
  "Braeden",
  "Calder",
  "Darian",
  "Emeric",
  "Finnian",
  "Gage",
  "Huxley",
  "Icarus",
  "Jaxon",
  "Kasper",
  "Lysander",
  "Maxim",
  "Niles",
  "Osiris",
  "Peregrine",
  "Quillan",
  "Remy",
  "Sterling",
  "Titus",
  "Uriah",
  "Vance",
  "Warrick",
  "Xeno",
  "Yates",
  "Zander",
  "Ajax",
  "Beckett",
  "Cassius",
  "Dante",
  "Evander",
  "Fox",
  "Griffin",
  "Hawke",
  "Iago",
  "Jagger",
  "Keaton",
  "Lachlan",
  "Maverick",
  "Nero",
  "Orion",
  "Phoenix",
  "Quinlan",
  "Raze",
  "Storm",
  "Titan",
  "Ulysses",
  "Vaughn",
  "Wilder",
  "Xavian",
  "Ysrael",
  "Zoltan",
  "Atlas",
  "Blaze",
  "Chaos",
  "Diablo",
  "Eclipse",
  "Fury",
  "Ghost",
  "Havoc",
  "Inferno",
  "Jinx",
  "Kraken",
  "Leviathan",
  "Morpheus",
  "Nether",
  "Onyx",
  "Phoenix",
  "Ragnarok",
  "Shadow",
  "Titan",
  "Umbra",
  "Vortex",
  "Wyvern",
];

export const defaultPlayerName =
  playerNames[Math.floor(Math.random() * playerNames.length)];

export const defaultTownName =
  townNames[Math.floor(Math.random() * townNames.length)];

const randomVillagerName =
  villagerNames[Math.floor(Math.random() * villagerNames.length)];
const randomFighterName =
  fighterNames[Math.floor(Math.random() * fighterNames.length)];
const randomArcherName =
  archerNames[Math.floor(Math.random() * archerNames.length)];
const randomKnightName =
  knightNames[Math.floor(Math.random() * knightNames.length)];
const randomMageName = mageNames[Math.floor(Math.random() * mageNames.length)];
const randomBombirdName =
  bombirdNames[Math.floor(Math.random() * bombirdNames.length)];

export const randomUnitNames = {
  villager: randomVillagerName,
  fighter: randomFighterName,
  archer: randomArcherName,
  knight: randomKnightName,
  mage: randomMageName,
  bombird: randomBombirdName,
};
